import collect from 'collect.js';

window.calpak = window.calpak || {}
const calpak = window.calpak
calpak.collect = collect

calpak.collections = calpak.collections || []
calpak.domLoaded = calpak.domLoaded || false
calpak.domParsed = calpak.domParsed || false
calpak.loaded = false

calpak.debounce = (callback, delay = 500) => {
    let timer;
    return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(() => {
            // console.log('executing debounce callback')
            callback(...args);
        }, delay)
    }
}

calpak.loadScript = function (src) {
    return new Promise((resolve, reject) => {
        const s = document.createElement("script");

        s.setAttribute("src", src);
        s.addEventListener("load", resolve);
        s.addEventListener("error", reject);

        document.body.appendChild(s);
    });
}
